import React from "react";

import TitleSection from "../TitleSection/TitleSection";
import SelectableButton from "../ui/SelectableButton/selectableButton";
import styles from "./PaymentMethods.module.sass";

const paymentMethods = props => {
  return (
    <div>
      <TitleSection
        title={
          props.allowCC
            ? "Como deseja pagar a parcela de adesão?"
            : "E as demais parcelas?"
        }
      />
      <div className={styles.chooser}>
        {props.allowCC && (
          <SelectableButton
            selected={props.value === "CC"}
            className={styles.paymentButton}
            buttonClass={styles.innerButton}
            onClick={() => props.selectedMethod("CC")}
            blue
            leftIcon="icon-credito"
          >
            Cartão <span className={styles.fullText}>de crédito</span>
          </SelectableButton>
        )}
        <SelectableButton
          selected={props.value === "DB"}
          className={styles.paymentButton}
          buttonClass={styles.innerButton}
          onClick={() => props.selectedMethod("DB")}
          blue
          leftIcon="icon-pagamento"
        >
          Débito <span className={styles.fullText}>em conta Caixa</span>
        </SelectableButton>
        <SelectableButton
          selected={props.value === "BB"}
          className={styles.paymentButton}
          buttonClass={styles.innerButton}
          onClick={() => props.selectedMethod("BB")}
          blue
          leftIcon="icon-boleto-p"
        >
          Boleto
        </SelectableButton>
      </div>
    </div>
  );
};

export default paymentMethods;
